module.exports = __webpack_public_path__ + "img/11.34b57983.jpg";